//=>
// Main Heading
export default function Logo() {
  return <h1>Going Far Away 🏖️</h1>;
}
